import * as core from '../../../../../../../core'

import { query } from './create-change-impact-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'create.change.impact.modal',
    description:
      'Modal for creating a change impact, including linked personas (Change360)',
    name: 'Create Change Impact Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
